<template>
  <div class="wrapper-bar-3">
    <div class="grid">
      <router-link
        :to="
          $i18nRoute({
            name: 'NewsDetail',
            params: { slug: item.url }
          })
        "
        v-for="(item, index) in list.slice(0, 12)"
        :key="item.id"
        class="grid__item"
      >
        <div class="card" :class="`card-${index + 1}`">
          <div class="card__img">
            <div class="card__category">{{ item.sub_category.name }}</div>
            <ImageContainer
              :src="item.image.medium"
              :thumb="item.image.thumbnail"
              :alt="item.title"
            />
            <i v-if="item.video" class="fas fa-play-circle icon-player"></i>
          </div>
          <div class="card__descr">
            <div class="card__title limited-text">{{ item.title }}</div>
            <div class="data-news">
              <span class="day">{{ handleDate(item.pub_date) }},</span>
              <span class="time">{{ handleTime(item.pub_date) }}</span>
            </div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";

export default {
  components: { ImageContainer },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
.wrapper-bar-3 {
  --gap-row: 3rem;

  position: relative;
  overflow: hidden;
  width: 100%;
  &::after {
    content: "";
    position: absolute;
    width: 100vw;
    height: 50%;
    background-color: var(--foreground-color);
    top: 0;
    left: 50%;
    @media screen and (max-width: 992px) {
      display: none;
    }
  }
  &::before {
    content: "";
    position: absolute;
    width: 100vw;
    height: 50%;
    background-color: var(--foreground-color);
    top: 50%;
    right: 50%;
    @media screen and (max-width: 992px) {
      display: none;
    }
  }
  @media screen and (max-width: 992px) {
    margin: 1.5rem 0;
    width: 100%;
  }
  @media screen and (max-width: 767px) {
    margin: 0;
    padding: 2.5rem 0 1rem;
  }
}
.grid {
  width: 100%;
  max-width: var(--width-media);
  margin: 0 auto;
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: repeat(18, 1fr);
  gap: var(--gap-row) 1.8rem;
  padding: var(--gap-row) 0;

  &__item:nth-child(1) {
    grid-column: 1 / span 8;
    grid-row: span 4;
    align-self: center;
    // justify-self: center;
  }
  &__item:nth-child(2) {
    grid-column: 10 / span 4;
    grid-row: span 4;
    align-self: center;
  }
  &__item:nth-child(3) {
    grid-column: 14 / span 5;
  }
  &__item:nth-child(4) {
    grid-column: 14 / span 5;
  }
  &__item:nth-child(5) {
    grid-column: 14 / span 5;
  }
  &__item:nth-child(6) {
    grid-column: 14 / span 5;
  }
  &__item:nth-child(7) {
    grid-column: 1 / span 4;
    grid-row: span 4;
    align-self: center;
  }

  &__item:nth-child(8) {
    grid-column: 5 / span 5;
  }
  &__item:nth-child(9) {
    grid-column: 5 / span 5;
  }
  &__item:nth-child(10) {
    grid-column: 5 / span 5;
  }
  &__item:nth-child(11) {
    grid-column: 5 / span 5;
  }
  &__item:nth-child(12) {
    grid-column: 11 / span 9;
    grid-row: 5 / span 4;
    align-self: center;
    // justify-self: center;
  }
}
.card {
  &__title {
    margin-top: 0.5rem;
    font-family: Roboto;
    font-weight: 400;
    font-size: calc(min(1.25em, 1vw));
    line-height: 1.3em;
    @media screen and (max-width: 1100px) {
      font-size: calc(min(1.25em, 1.3vw));
    }
    @media screen and (max-width: 992px) {
      font-family: Roboto;
      font-style: normal;
      font-size: 16px !important;
      line-height: 22px;
    }
    @media screen and (max-width: 767px) {
      font-family: Roboto;
      font-size: 12px !important;
      line-height: 15px !important;
      color: var(--primary-font-color);
    }
  }
  .data-news {
    font-family: Open Sans;
    font-size: calc(min(0.9em, 0.85vw));
    line-height: 19px;
    margin-top: 8px;
    @media screen and (max-width: 992px) {
      font-family: Open Sans;
      font-size: 13px;
      line-height: 18px;
      color: var(--category-color);
    }
    @media screen and (max-width: 767px) {
      font-family: Open Sans;
      font-size: 10px;
      line-height: 14px;
    }
  }
  &__img {
    height: 100px;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
  }
  &__category {
    position: absolute;
    z-index: 3;
    font-family: Open Sans;
    font-size: 0.88em;
    line-height: 19px;
    color: var(--category-color);
    background: var(--background-color);
    padding: 3px;
    @media screen and (max-width: 992px) {
      font-family: Open Sans;
      font-weight: 600;
      font-size: 13px;
      line-height: 18px;
      text-transform: uppercase;
      background: var(--background-color) !important;
    }
    @media screen and (max-width: 767px) {
      font-family: Open Sans;
      font-weight: 600;
      font-size: 10px;
      line-height: 14px;
    }
  }
}
.card-1,
.card-12 {
  width: 28vw;
  margin: 0 auto;
  .card__img {
    height: 15.8vw;
    width: 100%;
  }
  .card__descr {
    text-align: center;
    width: 90%;
    margin: 0 auto;
  }
}
.card-8 {
  padding-top: var(--gap-row);
}
.card-2,
.card-7 {
  padding: 0 1em;
  .card__img {
    height: 10.5vw;
  }
}

.card-3,
.card-4,
.card-5,
.card-6,
.card-8,
.card-9,
.card-10,
.card-11 {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  .card__img {
    height: calc(max(119px, 5.66vw));
    flex: 0 0 42%;
  }
  .card__title {
    --snup: 6;
    margin-top: 0;
    font-size: calc(min(1.06em, 1vw));

    @media screen and (max-width: 1100px) {
      font-size: calc(min(1.15em, 1.1vw));
    }
  }
}

.card-2,
.card-3,
.card-4,
.card-5,
.card-6,
.card-7,
.card-8,
.card-9,
.card-10,
.card-11 {
  color: var(--background-color);
  .card__category {
    background-color: var(--foreground-color);
  }
  .data-news {
    color: var(--category-color);
    font-style: normal;
    font-weight: normal;
  }
}
@media screen and (max-width: 992px) {
  .grid {
    padding: 0;
    gap: 0;
    &__item {
      grid-column: span 18 !important;
      grid-row: span 1 !important;
      width: 100%;
      .card {
        &__img {
          height: 100px;
        }
      }
    }
    &__item:nth-child(1) {
      align-self: flex-start;
      justify-self: start;
    }
  }
  .card {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    .card__title {
      color: var(--primary-font-color);
    }
    .card__descr {
      text-align: left;
    }
    .card__img {
      flex: 0 0 58%;
      height: 237px;
    }
  }
  .card-1,
  .card-2,
  .card-3,
  .card-10,
  .card-11,
  .card-12 {
    margin-bottom: 2rem;
  }
  .card-4,
  .card-5,
  .card-6,
  .card-7,
  .card-8,
  .card-9 {
    padding: 0;
    .card__img {
      border-radius: 1px;
      flex: 0 0 50%;
      height: 207px;
      :deep().main-image {
        border-radius: 0px;

        img {
          border-radius: 0px;
        }
      }
    }
  }
  .card-9 {
    margin-bottom: 2rem;
  }
  .card-5,
  .card-7,
  .card-9 {
    flex-direction: row-reverse;
  }
  .card-1,
  .card-12 {
    width: 100%;
  }
}
@media screen and (max-width: 767px) {
  .grid {
    display: grid;
    gap: 1rem 0 !important;
    &__item {
      grid-column: span 9 !important;
    }
    &__item:nth-child(1),
    &__item:nth-child(12) {
      grid-column: span 18 !important;
    }
  }
  .card-1,
  .card-12 {
    padding: 0 !important;
    .card__img {
      height: 212px !important;
    }
    .card__descr {
      text-align: center;
    }
  }
  .card {
    display: block;
    margin: 0 !important;
    padding: 0 0.8rem;
    .card__img {
      height: 90px;
    }
  }
  .card-4,
  .card-5,
  .card-6,
  .card-7,
  .card-8,
  .card-9 {
    .card__img {
      :deep().main-image {
        border-radius: 4px;

        img {
          border-radius: 4px;
        }
      }
    }
  }
}
.icon-player {
  position: absolute;
  bottom: 10px;
  left: 10px;
  font-size: 1.2rem;
  color: var(--primary-font-color);
}
</style>
